module.exports = __webpack_public_path__ + "img/3-center.7c75ad52.svg";